const NAME_TITLE = 'Name';
const SIZE_TITLE = 'Size';

export const ASSET_COLUMNS_NAME = {
  NAME: 'fileName',
  SIZE: 'fileSize',
  ACTIONS: 'actions'
};

export const ASSET_TABLE_PAGE_SIZES = [10, 25, 50, 100];

export const ASSET_TABLE_COLUMNS = [
  { name: ASSET_COLUMNS_NAME.NAME, title: NAME_TITLE },
  { name: ASSET_COLUMNS_NAME.SIZE, title: SIZE_TITLE },
  { name: ASSET_COLUMNS_NAME.ACTIONS, title: ' ' }
];

export const ASSET_TABLE_COLUMNS_WIDTH = [
  { columnName: ASSET_COLUMNS_NAME.SIZE, width: 340, resizingEnabled: false },
  {
    columnName: ASSET_COLUMNS_NAME.ACTIONS,
    width: 45,
    resizingEnabled: false
  },
  {
    columnName: ASSET_COLUMNS_NAME.NAME,
    width: undefined,
    resizingEnabled: false
  }
];
